/**
 * API Configuration File
 * 
 * This file contains all API base URLs for different environments.
 * Change the CURRENT_ENV variable to switch between environments.
 */

// Environment options
const ENVIRONMENTS = {
  LOCAL: 'local',
  QA: 'qa',
  PROD: 'prod'
};

// Base URLs for each environment
const API_URLS = {
  [ENVIRONMENTS.LOCAL]: 'http://localhost:7000',
  [ENVIRONMENTS.QA]: 'https://varapi.vthinkglobal.com', // Update with your QA URL
  [ENVIRONMENTS.PROD]: 'https://api.yourdomain.com'   // Update with your production URL
};

// CHANGE THIS TO SWITCH ENVIRONMENTS
const CURRENT_ENV = ENVIRONMENTS.QA;



export const API_BASE_URL = API_URLS[CURRENT_ENV];

// Export all environments for reference
export { ENVIRONMENTS };


export const API_ENDPOINTS = {
  
  EMPLOYEE: `${API_BASE_URL}/api/employee`,
  
  LEADS: `${API_BASE_URL}/api/common/leads`,
  LEADS_DROPDOWN: `${API_BASE_URL}/api/employee/lead-dropdown`,

  PROJECTS: `${API_BASE_URL}/api/common/project`,
  SUBMIT_PROJECTS: `${API_BASE_URL}/api/project`,

  PMS:`${API_BASE_URL}/api/common/pm`,
  PMS_DROPDOWN:`${API_BASE_URL}/api/employee/pm-dropdown`,
  
  SUBMIT_LEAD_PM: `${API_BASE_URL}/api/employee/register-role`,
  SEND_MAIL: `${API_BASE_URL}/api/common/send-mail`,
  
  REPORT: `${API_BASE_URL}/api/report`,
  
  UPLOAD: `${API_BASE_URL}/api/upload`,
  UPLOAD_HISTORY: `${API_BASE_URL}/api/upload_history`
};

export default API_BASE_URL;
